import {
  FaTachometerAlt,
  FaUser,           
  FaUserTie,         
  FaUserShield,          
  FaBox,
  FaTicketAlt,
  FaStar,
  FaBell,
  FaCog,
  FaComments,
  FaBlog,
  FaMapMarkedAlt,
} from 'react-icons/fa';

export const MenuData = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: FaTachometerAlt,
    path: '/admin/dashboard',
    hasSubmenu: false,
  },

  // ── Customers (ex-submenu item) ──
  {
    id: 'customers',
    label: 'Customers Management' ,
    icon: FaUser,
    path: '/admin/users/customers',
    hasSubmenu: false,
  },

  // ── Vendors (ex-submenu item) ──
  {
    id: 'vendors',
    label: 'Vendors Management',
    icon: FaUserTie,
    path: '/admin/users/vendors',
    hasSubmenu: false,
  },

  // ── Admins (ex-submenu item) ──
  {
    id: 'admins',
    label: 'Admins Management',
    icon: FaUserShield,
    path: '/admin/users/admins',
    hasSubmenu: false,
  },

  // {
  //   id: 'bookings',
  //   label: 'Hotel Booking Management',
  //   icon: FaTicketAlt,
  //   path: '/admin/vendor-booking-management',
  //   hasSubmenu: false,
  // },

  {
    id: 'packages',
    label: 'Package Management',
    icon: FaBox,
    path: '/admin/packages',
    hasSubmenu: false,
  },

  {
    id: 'destinations',
    label: 'Destination Management',
    icon: FaMapMarkedAlt,
    path: '/admin/destinations',
    hasSubmenu: false,
  },

  {
    id: 'reviews',
    label: 'Reviews & Ratings',
    icon: FaStar,
    path: '/admin/reviews',
    hasSubmenu: false,
  },

  {
    id: 'notifications',
    label: 'Notifications',
    icon: FaBell,
    path: '/admin/notifications',
    hasSubmenu: false,
  },

  {
    id: 'blogs',
    label: 'Blog Management',
    icon: FaBlog,
    path: '/admin/blogs',
    hasSubmenu: false,
  },

  {
    id: 'settings',
    label: 'Settings',
    icon: FaCog,
    path: '/admin/settings',
    hasSubmenu: false,    // changed to direct link (no dropdown)
  },

  {
    id: 'support',
    label: 'Support & Help',
    icon: FaComments,
    hasSubmenu: true,
    submenu: [
      { id: 'support-tickets', label: 'Support Tickets', path: '/admin/support-tickets' },
      { id: 'support-faq',     label: 'FAQ Management',  path: '/admin/support/faq'     },
    ],
  },
];